export default __webpack_public_path__ + "8e34f83f6c5b45291b4e728f64a9c2ef.png";